import reducer from "./reducers";

export { default as loaderOperations } from "./operations";


export default reducer;
